import {Component, Input, OnInit} from '@angular/core';
import {NavController, Platform} from '@ionic/angular';
import {Plugins, StatusBarStyle} from '@capacitor/core';
import {Router} from "@angular/router";

const AndroidStatusBar = Plugins.StatusBar;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {

    @Input() title = '';
    @Input() back = null;
    @Input() close = null;
    @Input() replace = false;

    @Input() fixed = false;

    constructor(private platform: Platform, private router: Router, private navController: NavController) {
    }

    ngOnInit() {
        if (this.platform.is('android')) {
            AndroidStatusBar.setStyle({style: StatusBarStyle.Light});
            AndroidStatusBar.setBackgroundColor({
                color: '#EDE3D7',
            });
        }
    }

    goBack() {
        if (this.back) {
            this.navController.navigateBack(this.back, {
                replaceUrl: this.replace
            });
        } else {
            this.navController.back();
        }
    }

    doClose() {
        if (this.close) {
            this.router.navigate([ this.close ], { replaceUrl: true });
        }
    }
}
